import React, { useState } from 'react';
import { Button, Col, Form, Input, Row, Typography } from 'antd';

const { Text } = Typography;

const EditFormField = ({ value, name, onSubmit, isLoading }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div>
      {isEditing ? (
        <Form onFinish={onSubmit}>
          <Row gutter={4}>
            <Col>
              <Form.Item name={name} initialValue={value}>
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <Button
                size="small"
                type="primary"
                htmlType="submit"
                loading={isLoading}>
                Submit
              </Button>
            </Col>
            <Col>
              <Button
                size="small"
                onClick={() => setIsEditing(false)}
                loading={isLoading}>
                Close
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Row align="middle" gutter={10}>
          <Col>
            <Text>{value}</Text>
          </Col>
          <Col>
            <Button size="small" onClick={() => setIsEditing(true)}>
              Edit
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default EditFormField;
